import { Pipe, PipeTransform } from '@angular/core';
import { Nalgene } from './nalgene';

@Pipe({
  name: 'RatingPipe'
})
export class RatingPipe implements PipeTransform {
    //this code use two parameters in the pipe

    transform(nalgene:Nalgene, storedChemical:string){
        let output: string;
        output = "N/A";
        //console.log(storedChemical);
        //output = storedChemical;
        if(storedChemical != ""){
        output = nalgene[`${storedChemical}`]
        }
        return output;

    }

       
}


// WEBPACK FOOTER //
// /Users/thomas.obrien2/projects/nalgene/src/app/categories/rating.pipe.ts